<template>
  <modal-template
    ref="modal"
    modal-size="sm"
    title="Editar metas mensais do Segmento"
    type-modal="edit_goal_modal"
  >
    <div class="modal-content__main">
      <ul>
        <li v-for="goal in drive.goals" :key="goal.id" class="form-group">
          <label>{{ goal.month }}</label>
          <d-input-group prepend="R$">
            <input-currency
              model-index="value"
              placeholder="Meta"
              :model="goal"
            ></input-currency>
          </d-input-group>
        </li>
      </ul>
    </div>

    <div slot="actions" class="modal-content__control" >
      <loader v-if="loading" :fullPage="false" class="mr-4"/>
      <d-button
        type="button"
        :disabled="loading"
        @click="save()"
        class="btn btn-sm btn-primary"
      >Salvar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import ModalTemplate from '_shared/Modal.vue';
import InputCurrency from '_shared/InputCurrency.vue';
import { _LOAD_DRIVE_GOAL_, _SAVE_DRIVE_GOAL_, MODEL_DRIVE } from './SettingsModel';

export default {
  name: 'drive-goals-modal',
  data() {
    return {
      drive: MODEL_DRIVE,
      loading: false,
    };
  },
  components: {
    Loader,
    InputCurrency,
    ModalTemplate,
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    save() {
      Events.$emit(_SAVE_DRIVE_GOAL_, this.drive);
      this.setToggle({ type: 'edit_goal_modal', bool: false });
    },
  },
  mounted() {
    Events.$on(_LOAD_DRIVE_GOAL_, drive => {
      this.drive = drive;
    });
  },
};
</script>

<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
/deep/.modal-body {
  padding: 1.8rem 1.18rem .8rem 1.18rem!important;
}
.modal-content__main {
  ul {
    list-style: none;
    padding: 0;
    li {
      display: flex;
      align-items: center;
      label {
        width: 100px;
        margin: 0;
      }
    }
  }
}
</style>
